import { useState } from "react";
import { Drop } from "../types";
import { DROPS } from "../data/drops";
import { FONTS, GRAD, PINK, YELLOW, CREAM, CARD_BORDER, CARD_BG } from "../data/affirmations";
import { RouteMap } from "./RouteMap";

interface DropsTabProps {
  onStartWalk: (drop: Drop) => void;
}

export function DropsTab({ onStartWalk }: DropsTabProps) {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <div style={{ animation: "fadeUp 0.4s ease" }}>
      <style>{FONTS + `@keyframes fadeUp { from { opacity:0;transform:translateY(16px) } to { opacity:1;transform:translateY(0) } }`}</style>

      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontSize: "9px", letterSpacing: "5px", color: PINK, textTransform: "uppercase", fontWeight: 700, fontFamily: "'Poppins',sans-serif", marginBottom: "4px" }}>this week</div>
        <div style={{ fontFamily: "'Poppins',sans-serif", fontSize: "28px", fontWeight: 900, color: "#1a1a1a", letterSpacing: "-1px", lineHeight: 1 }}>Weekly Drops</div>
      </div>

      {/* Vibe banner */}
      <div style={{ background: GRAD, borderRadius: "16px", padding: "14px 18px", marginBottom: "16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: "9px", fontWeight: 700, letterSpacing: "2px", color: "rgba(255,255,255,0.8)", textTransform: "uppercase", fontFamily: "'Poppins',sans-serif" }}>this week's vibe</div>
          <div style={{ fontSize: "16px", fontWeight: 800, color: "#fff", fontFamily: "'Poppins',sans-serif" }}>Back to Black Era</div>
        </div>
        <div style={{ fontSize: "28px" }}>🖤</div>
      </div>

      {DROPS.map(drop => {
        const isExpanded = expandedId === drop.id;
        const isLimitedCard = drop.isLimited;

        return (
          <div key={drop.id} style={{ background: isLimitedCard ? CARD_BG : "#fff", borderRadius: "18px", overflow: "hidden", marginBottom: "10px", border: `1px solid ${isLimitedCard ? "#FFD6EC" : CARD_BORDER}` }}>
            {!isLimitedCard && <div style={{ height: "3px", background: GRAD }} />}
            <div
              onClick={() => setExpandedId(isExpanded ? null : drop.id)}
              style={{ padding: "16px 18px", cursor: "pointer" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  {isLimitedCard && (
                    <span style={{ background: PINK, color: "#fff", fontSize: "8px", fontWeight: 700, letterSpacing: "1px", padding: "3px 8px", borderRadius: "4px", fontFamily: "'Poppins',sans-serif", textTransform: "uppercase" }}>Limited</span>
                  )}
                  {!isLimitedCard && (
                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                      <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: GRAD }} />
                      <span style={{ fontSize: "8px", fontWeight: 700, letterSpacing: "1.5px", color: PINK, textTransform: "uppercase", fontFamily: "'Poppins',sans-serif" }}>Drop</span>
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  {drop.isLimited && drop.expiresIn && (
                    <span style={{ fontSize: "10px", color: PINK, fontFamily: "'Poppins',sans-serif", fontWeight: 700 }}>
                      {drop.expiresIn} ⏰
                    </span>
                  )}
                  <span style={{ fontSize: "14px", color: "#ccc" }}>{isExpanded ? "↑" : "↓"}</span>
                </div>
              </div>

              <div style={{ fontSize: "20px", fontWeight: 800, color: "#1a1a1a", letterSpacing: "-0.5px", lineHeight: 1.1, fontFamily: "'Poppins',sans-serif", marginBottom: "3px" }}>{drop.title}</div>
              <div style={{ fontSize: "11px", color: isLimitedCard ? PINK : "#999", fontFamily: "'Poppins',sans-serif", fontWeight: isLimitedCard ? 600 : 400 }}>{drop.neighbourhood} · {drop.subtitle}</div>

              {!isExpanded && (
                <div style={{ display: "flex", gap: "12px", marginTop: "10px" }}>
                  <span style={{ fontSize: "11px", color: "#bbb", fontFamily: "'Poppins',sans-serif" }}>{drop.distance}</span>
                  <span style={{ fontSize: "11px", color: "#bbb", fontFamily: "'Poppins',sans-serif" }}>{drop.time}</span>
                </div>
              )}
            </div>

            {isExpanded && (
              <div style={{ padding: "0 18px 18px" }}>
                <p style={{ fontSize: "13px", color: "#777", lineHeight: 1.7, marginBottom: "14px", fontFamily: "'Poppins',sans-serif", fontStyle: "italic" }}>{drop.inspo}</p>

                <div style={{ marginBottom: "14px" }}>
                  <RouteMap drop={drop} compact={true} />
                </div>

                <div style={{ display: "flex", paddingTop: "12px", borderTop: `1px solid ${CARD_BORDER}`, marginBottom: "14px" }}>
                  {[
                    { label: "Distance", val: drop.distance },
                    { label: "Est. Time", val: drop.time },
                    { label: "Area", val: drop.neighbourhood.split(",")[0] },
                  ].map((s, i) => (
                    <div key={s.label} style={{ flex: 1, borderRight: i < 2 ? `1px solid ${CARD_BORDER}` : "none", paddingRight: i < 2 ? "12px" : "0", paddingLeft: i > 0 ? "12px" : "0" }}>
                      <div style={{ fontSize: "17px", fontWeight: 800, color: "#1a1a1a", fontFamily: "'Poppins',sans-serif" }}>{s.val}</div>
                      <div style={{ fontSize: "9px", color: "#bbb", textTransform: "uppercase", letterSpacing: "1px", fontFamily: "'Poppins',sans-serif" }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                <div style={{ marginBottom: "14px", paddingBottom: "14px", borderBottom: `1px solid ${CARD_BORDER}` }}>
                  <div style={{ fontSize: "9px", color: "#bbb", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "8px", fontFamily: "'Poppins',sans-serif" }}>route stops</div>
                  {drop.landmarks.map((l, i) => (
                    <div key={i} style={{ fontSize: "12px", color: "#666", padding: "3px 0", fontFamily: "'Poppins',sans-serif" }}>· {l}</div>
                  ))}
                </div>

                <div style={{ background: CREAM, border: `1px solid ${CARD_BORDER}`, borderRadius: "14px", padding: "12px 14px", marginBottom: "14px", display: "flex", alignItems: "center", gap: "12px" }}>
                  <div style={{ fontSize: "24px" }}>{drop.playlistEmoji}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "9px", color: "#bbb", letterSpacing: "2px", textTransform: "uppercase", fontFamily: "'Poppins',sans-serif" }}>paired playlist</div>
                    <div style={{ fontFamily: "'Poppins',sans-serif", fontWeight: 700, fontSize: "14px", color: "#1a1a1a" }}>{drop.playlistName}</div>
                    <div style={{ fontSize: "11px", color: "#999", fontFamily: "'Poppins',sans-serif" }}>{drop.bpm}</div>
                  </div>
                  <button
                    onClick={() => window.open(drop.spotifyUrl, "_blank")}
                    style={{ background: "#1DB954", borderRadius: "50px", padding: "7px 14px", color: "#000", fontWeight: 700, fontSize: "12px", border: "none", cursor: "pointer", fontFamily: "'Poppins',sans-serif" }}>
                    Play
                  </button>
                </div>

                <button
                  onClick={() => onStartWalk(drop)}
                  style={{ width: "100%", padding: "14px", borderRadius: "12px", border: "none", cursor: "pointer", background: GRAD, color: "#fff", fontSize: "13px", fontWeight: 700, letterSpacing: "0.5px", fontFamily: "'Poppins',sans-serif", boxShadow: "0 6px 20px rgba(255,105,180,0.3)" }}>
                  Slay This Walk ✨
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
